import React from 'react'
import styled from 'styled-components'
import { renderMenu } from './CategoriesDetails'
import Expand from '../icons/Expand'
import Collapse from '../icons/Collapse'
import isEmpty from 'lodash/isEmpty'
import Link from 'next/link'
import { trackCategoryClickedEvent } from '../../lib/analytics/events/category/CategoryClickedEvent'

const StyledLi = styled.li`
  position: relative;
`
const ItemLink = styled.a`
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1.43;
  color: #1557bf;
  text-decoration: none;
  margin-bottom: 1.125rem;
  display: block;
`

const StyledSpan = styled.span`
  margin-bottom: 1.25rem;
  color: #333333;
  display: block;
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1.43;
`

const ShowMoreArrow = styled(Expand)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: #1557bf;
  cursor: pointer;
  height: 1.5rem;
  width: 1.5rem;
`
const StyledCollabse = styled(Collapse)`
  position: absolute;
  right: 0;
  top: 0;
  color: #1557bf;
  cursor: pointer;
  height: 1.5rem;
  width: 1.5rem;
`

class RenderMenu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showMore: false,
      checkoutAddress: props.checkoutAddress,
      level: props.level || 3, // default level to 3 if not provided
    }

    this.handleShowMoreProductList = this.handleShowMoreProductList.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  handleShowMoreProductList(e) {
    e.stopPropagation()
    this.setState(prevState => {
      return {
        showMore: !prevState.showMore,
      }
    })
  }

  handleClick(name) {
    trackCategoryClickedEvent({
      CATEGORY_NAME: name.toLowerCase(),
      CATEGORY_LEVEL: this.state.level,
      STORE_ID_DBP: this.state.checkoutAddress?.storeId?.toString() ?? '',
      STORE_ID_SAP: this.state.checkoutAddress?.clientId?.toString() ?? '',
    })
  }

  customListItem(item) {
    let { menu, name, url, id } = item

    if (!isEmpty(menu)) {
      return <StyledSpan>{name}</StyledSpan>
    } else {
      url = url.replace(/^\/?category\//, '')
      const nameToTrack = name ? encodeURIComponent(name) : ''
      return (
        <Link
          href={encodeURI(
            `/categoryDetails?slug=${encodeURIComponent(
              url
            )}&exclude_ga_track_name=${nameToTrack}&exclude_ga_track_id=${id}`
          )}
          as={`/category/${url}`}
          passHref
          legacyBehavior
        >
          <ItemLink onClick={() => this.handleClick(name)}>{name}</ItemLink>
        </Link>
      )
    }
  }

  render() {
    const { item } = this.props
    if (!item) {
      return null
    }

    return (
      <StyledLi onClick={this.handleShowMoreProductList}>
        {this.customListItem(item)}
        {this.state.showMore &&
          item.menu &&
          renderMenu(item.menu, item.name, item.url, item.id)}
        {!isEmpty(item.menu) &&
          (!this.state.showMore ? <ShowMoreArrow /> : <StyledCollabse />)}
      </StyledLi>
    )
  }
}

export default RenderMenu
